import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2714a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "templates-wrapper grid" }
const _hoisted_2 = {
  key: 0,
  class: "col-6"
}
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "p-inputgroup flex-1 col-12" }
const _hoisted_5 = { class: "col-12 flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn-sm" }, "並べ替え：", -1))
const _hoisted_9 = { class: "sort-by" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "list-template" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "template-title" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "header flex align-items-center justify-content-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, "プレビュー", -1))
const _hoisted_18 = { class: "pi pi-question-circle mr-3" }
const _hoisted_19 = { class: "body bg-blue-200 p-3" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "selected-template-wrapper flex gap-2"
}
const _hoisted_22 = { class: "clinic-logo-wrapper" }
const _hoisted_23 = {
  key: 0,
  class: "p-avatar p-component p-avatar-circle p-avatar-lg"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "selected-template-wrapper flex gap-2" }
const _hoisted_28 = { class: "clinic-logo-wrapper" }
const _hoisted_29 = {
  key: 0,
  class: "p-avatar p-component p-avatar-circle p-avatar-lg"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "selected-template-wrapper flex gap-2 mt-2"
}
const _hoisted_33 = { class: "clinic-logo-wrapper" }
const _hoisted_34 = {
  key: 0,
  class: "p-avatar p-component p-avatar-circle p-avatar-lg"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "col-12 flex justify-content-center" }

import { onBeforeMount, ref, inject, computed, toRefs } from "vue";
import { get, set, UseScrollReturn } from "@vueuse/core";
import { useStore } from "vuex";
import { vScroll } from "@vueuse/components";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import { LiveMessageTemplateServices } from "@/clinic/services";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import type { ApiLiveMessageTemplateIndexReq } from "@/clinic/typings";

export default /*#__PURE__*/_defineComponent({
  __name: 'LineMessageTemplate',
  props: {
    previewType: null,
    previewMessageContent: null,
    previewUrlContent: null,
    previewImageContent: null
  },
  emits: ["onClose", "onInsert"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  previewType: string;
  previewMessageContent: string;
  previewUrlContent?: string;
  previewImageContent?: string;
};

const store = useStore();

const clinicId = ref(0);
const selectedTemplate = ref({});
const searchTerm = ref<string>("");
const page = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const templates = ref({});
const linkUrl = ref(
  '<div class="mt-2"><a href "' + props.previewUrlContent + '">' + props.previewUrlContent + "</a></div>"
);
const imageUrl = ref('<img src="' + props.previewImageContent + '" alt="preview-image" class="w-100"/>');
const sortBy = ref({ name: "最近作成した定型文", code: "created_at" });
const sortOptions = ref([
  { name: "最近作成した定型文", code: "created_at" },
  { name: "最近利用した定型文", code: "last_used_date" },
]);

const clinicLogo = () => {
  return store.getters["authClient/selectedClinic"]?.logo_url;
};
const goToNewTemplate = () => {
  RouterUtils.goTo(RouterConstants.LIVE_MESSAGE_TEMPLATE_NEW_ROUTER_NAME);
};
const selectTemplate = (event, template) => {
  document.querySelectorAll(".template-detail").forEach(element => element.classList.remove("active"));
  event.currentTarget.classList.add("active");
  set(selectedTemplate, template);
};
const insertTemplate = async () => {
  await LiveMessageTemplateServices.useTemplate(
    { clinic_id: get(await get(clinicId)), id: get(selectedTemplate).id },
    () => emits("onInsert", get(selectedTemplate)),
    () => undefined
  );
};
const onClose = () => {
  emits("onClose");
};
const onSearch = async event => {
  set(page, 0);
  await fetchTemplates();
};
const onSort = async event => {
  set(page, 0);
  await fetchTemplates();
};
const paginatorParams = computed(() => {
  return { term: get(searchTerm), page: get(page), rows: get(rows), sort: get(sortBy).code };
});
const fetchTemplates = async () => {
  const { data } = await LiveMessageTemplateServices.fetchTemplates(
    { ...{ clinic_id: get(await get(clinicId)) }, ...get(paginatorParams) } as ApiLiveMessageTemplateIndexReq,
    () => undefined,
    () => undefined,
    () => undefined
  );
  set(templates, data.value.templates);
  set(totalCount, data.value.meta.total_count);
};
const onScroll = async (state: UseScrollReturn) => {
  const { arrivedState, directions } = state;
  const { bottom } = toRefs(arrivedState);
  const { bottom: toBottom } = toRefs(directions);
  if (get(toBottom) && get(bottom) && get(totalCount) != get(templates).length) {
    set(page, get(page) + 1);
    const { data } = await LiveMessageTemplateServices.fetchTemplates(
      { ...{ clinic_id: get(await get(clinicId)) }, ...get(paginatorParams) } as ApiLiveMessageTemplateIndexReq,
      () => undefined,
      () => undefined,
      () => undefined
    );
    set(templates, [...get(templates), ...data.value.templates]);
  }
};
onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  fetchTemplates();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.previewType != 'preview')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputText, {
                modelValue: searchTerm.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
                placeholder: "タイトルを入力"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                class: "text-white",
                icon: "pi pi-search",
                onClick: onSearch
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, "メッセージ " + _toDisplayString(totalCount.value), 1),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Dropdown, {
                    modelValue: sortBy.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortBy).value = $event)),
                    options: sortOptions.value,
                    optionLabel: "name",
                    class: "w-full",
                    onChange: onSort
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "template-detail cursor-pointer",
                    key: template.id,
                    onClick: ($event: any) => (selectTemplate($event, template))
                  }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(template.title), 1),
                    _createElementVNode("div", {
                      class: "template-message mt-3",
                      innerHTML: template.content
                    }, null, 8, _hoisted_14)
                  ], 8, _hoisted_12))
                }), 128))
              ])), [
                [_unref(vScroll), onScroll]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Button, {
                class: "w-full p-button-light",
                label: "定型文を作成",
                onClick: goToNewTemplate
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(props.previewType == 'add' ? 'col-6' : 'col-12 message-preview-container')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["preview-wrapper", { 'choose-template-message-container': __props.previewType === 'add' }])
      }, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("span", _hoisted_18, null, 512), [
            [
              _directive_tooltip,
              '端末やOSによっては、実際に表示される画面と異なる場合があります。',
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (props.previewType == 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (selectedTemplate.value.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (clinicLogo())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("img", {
                                class: "user-avatar border-circle",
                                src: clinicLogo(),
                                alt: "user-avatar"
                              }, null, 8, _hoisted_24)
                            ]))
                          : (_openBlock(), _createBlock(_component_Avatar, {
                              key: 1,
                              icon: "pi pi-user",
                              size: "large",
                              shape: "circle"
                            }))
                      ]),
                      _createElementVNode("div", {
                        class: "template-content border-round-2xl",
                        innerHTML: selectedTemplate.value.content
                      }, null, 8, _hoisted_25)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    (clinicLogo())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("img", {
                            class: "user-avatar border-circle",
                            src: clinicLogo(),
                            alt: "user-avatar"
                          }, null, 8, _hoisted_30)
                        ]))
                      : (_openBlock(), _createBlock(_component_Avatar, {
                          key: 1,
                          icon: "pi pi-user",
                          size: "large",
                          shape: "circle"
                        }))
                  ]),
                  _createElementVNode("div", {
                    class: "template-content border-round-2xl",
                    innerHTML: props.previewUrlContent ? props.previewMessageContent + linkUrl.value : props.previewMessageContent
                  }, null, 8, _hoisted_31)
                ]),
                (props.previewImageContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (clinicLogo())
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createElementVNode("img", {
                                class: "user-avatar border-circle",
                                src: clinicLogo(),
                                alt: "user-avatar"
                              }, null, 8, _hoisted_35)
                            ]))
                          : (_openBlock(), _createBlock(_component_Avatar, {
                              key: 1,
                              icon: "pi pi-user",
                              size: "large",
                              shape: "circle"
                            }))
                      ]),
                      _createElementVNode("div", {
                        class: "template-content border-round-2xl mt-3 w-50",
                        innerHTML: imageUrl.value
                      }, null, 8, _hoisted_36)
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_Button, {
        class: "p-button-light mr-4",
        label: "キャンセル",
        onClick: onClose
      }),
      (props.previewType == 'add')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "text-white",
            label: "選択",
            onClick: insertTemplate,
            disabled: selectedTemplate.value.content == undefined
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})